import React from "react";
import { connect } from "react-redux";
import Select from "react-select";

class SelectClient extends React.Component {
  constructor(props) {
    super(props);
    var options = [];
    props.residents.map((resident) => {
      options.push({
        value: resident.id,
        label: `${resident.name}`,
      });
    });

    this.state = {
      options: options,
      selectedOption: null,
    };
  }

  render() {
    const { options, selectedOption } = this.state;
    return (
      <div className="pl-3 ml-3">
        <div className="row" style={{ justifyContent: "center" }}>
          <Select
            isClearable
            placeholder="Select Client..."
            className="col-xs-12 col-lg-4 ml-0 pl-0"
            options={options}
            value={selectedOption}
            onChange={(option) => {
              this.setState(() => {
                return { selectedOption: option };
              });
              this.props.dispatch({
                type: "UPDATE_FILTERS",
                payload: {
                  resident_id: option ? option.value : null,
                },
              });
            }}
          />
        </div>
      </div>
    );
  }
}

export default connect()(SelectClient);
